<template>
  <div class="module-properties">
    <div class="form-group">
      <label>Tipo de Banco</label>
      <select v-model="config.dbType">
        <option value="postgres">PostgreSQL</option>
        <option value="mysql">MySQL</option>
        <option value="sqlserver">SQL Server</option>
        <option value="oracle">Oracle</option>
      </select>
    </div>
    
    <div class="form-group">
      <label>Host</label>
      <input type="text" v-model="config.host" placeholder="Endereço do servidor">
    </div>
    
    <div class="form-group">
      <label>Porta</label>
      <input type="number" v-model="config.port" placeholder="Porta">
    </div>
    
    <div class="form-group">
      <label>Banco de Dados</label>
      <input type="text" v-model="config.database" placeholder="Nome do banco">
    </div>
    
    <div class="form-group">
      <label>Usuário</label>
      <input type="text" v-model="config.username" placeholder="Nome de usuário">
    </div>
    
    <div class="form-group">
      <label>Senha</label>
      <input type="password" v-model="config.password" placeholder="Senha">
    </div>
    
    <div class="form-group">
      <label>Consulta SQL</label>
      <textarea v-model="config.query" placeholder="SELECT * FROM tabela"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DbConnectionModuleProperties',
  props: {
    module: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      config: {
        dbType: 'postgres',
        host: 'localhost',
        port: 5432,
        database: '',
        username: '',
        password: '',
        query: '',
        ...this.module.config
      }
    };
  },
  watch: {
    config: {
      handler(newConfig) {
        this.$emit('update:config', newConfig);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.module-properties {
  padding: 10px;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
select, input, textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
textarea {
  min-height: 80px;
  resize: vertical;
}
</style>
